import {
    faFileDownload,
    faFileUpload,
    faPercentage,
    // faImages as fasImages,
    faLink,
    faChartLine,
    faTachometerAlt,
    faImage,
    faBullhorn,
    faFunnelDollar,
    faAd,
    faGrinAlt,
    faDollarSign,
    faEdit,
    faTimes,
    faStoreAltSlash,
    faSortDown,
    faMobileAlt,
    faDesktop,
    faBan,
    faTrash,
    faArchive,
    faHandHoldingUsd,
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowTrendUp,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faUser,
    faPhone,
    faSignature,
    faEnvelope,
    faLock,
    faUnlock,
    faSignInAlt,
    faRegistered,
    faSignOutAlt,
    faCog,
    faPencilAlt,
    faHeading,
    faCopy,
    faExternalLinkAlt,
    faUpload,
    faExclamation,
    faExchangeAlt,
    faCheck,
    faCheckCircle,
    faCircle,
    faTimesCircle,
    faExclamationCircle,
    faQuestionCircle,
    faMoneyBill,
    faTag,
    faCode,
    faTrashRestore,
    faEye,
    faEyeSlash,
    faBoxOpen,
    faNewspaper,
    faShoppingBag,
    faCertificate,
    faGraduationCap,
    faVideo,
    faPlus,
    faStar,
    faSave,
    faStore,
    faExclamationTriangle,
    faBell,
    faSms,
    faChevronLeft,
    faChevronDown,
    faSearch,
    faTicketAlt,
    faCommentAlt,
    faClock,
    faTasks,
    faKey,
    faGripLines,
    faCheckDouble,
    faDatabase,
    faFolder,
    faFileImage,
    faProjectDiagram,
    faUserEdit,
    faCoins,
    faUndo,
    faUserShield,
    faCrown,
    faFilter,
    faHeadset,
    faCogs,
    faChartBar,
    faGlobe,
    faHashtag,
    faWallet,
    faClipboardList,
    faBars,
    faThLarge,
    faShoppingBasket,
    faCloudArrowUp,
    faFilePdf,
    faPager,
    faHandshake,
    faDolly,
    faUserDoctor,
    faTowerBroadcast,
    faCircleDollarToSlot,
    faRotateLeft,
    faUserTie,
    faShoppingCart,
    faComment,
    faCartShopping,
    faBasketShopping,
    faDiamondTurnRight,
    faCalculator,
    faTruckFast,
    faTruck,
    faDollar,
    faFileContract,
    faAddressBook,
    faBullseye,
    faFaceSmile,
    faWindowMaximize,
    faMedal,
    faCommentSms,
    faPlay,
} from '@fortawesome/free-solid-svg-icons'

import {
    faImages as farImages,
    faCheckCircle as farCheckCircle,
    faEnvelope as farEnvelope,
    faFaceGrinStars as farFaceGrinStars,
    faCircleDot as farCircleDot,
} from '@fortawesome/free-regular-svg-icons'

import {
    faConnectdevelop,
    faTelegramPlane,
    faLinkedinIn,
    faInstagram,
    faGithub,
    faWordpress,
    faCreativeCommonsSamplingPlus,
    faTwitter,
    faTelegram,
    faWhatsapp,
    faYoutube,
    faFacebook,
    faProductHunt,
    faGratipay,
    faWpforms,
    faBloggerB,
} from '@fortawesome/free-brands-svg-icons'


export const IconsSet = Object.assign({}, {
    faShoppingBasket,
    faFileDownload,
    faFileUpload,
    faPercentage,
    // fasImages,
    farImages,
    faImage,
    faLink,
    faChartLine,
    faTachometerAlt,
    faBullhorn,
    faFunnelDollar,
    faAd,
    faGrinAlt,
    faDollarSign,
    faEdit,
    faTimes,
    faStoreAltSlash,
    faSortDown,
    faMobileAlt,
    faDesktop,
    faBan,
    faTrash,
    faConnectdevelop,
    faArchive,
    faHandHoldingUsd,
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowTrendUp,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faUser,
    faPhone,
    faSignature,
    faEnvelope,
    faLock,
    faUnlock,
    faSignInAlt,
    faRegistered,
    faSignOutAlt,
    faCog,
    faPencilAlt,
    faTelegramPlane,
    faLinkedinIn,
    faInstagram,
    faHeading,
    faCopy,
    faExternalLinkAlt,
    faUpload,
    faExclamation,
    faExchangeAlt,
    faCheck,
    faCheckCircle,
    faCircle,
    faTimesCircle,
    faExclamationCircle,
    faQuestionCircle,
    faMoneyBill,
    faTag,
    faCode,
    faTrashRestore,
    faEye,
    faEyeSlash,
    faBoxOpen,
    faNewspaper,
    faShoppingBag,
    faCertificate,
    faGraduationCap,
    faVideo,
    farCheckCircle,
    faPlus,
    faStar,
    faSave,
    faStore,
    faExclamationTriangle,
    faGithub,
    faWordpress,
    faBell,
    faSms,
    farEnvelope,
    faChevronLeft,
    faChevronDown,
    faSearch,
    faTicketAlt,
    faCommentAlt,
    faClock,
    faTasks,
    faKey,
    faGripLines,
    faCheckDouble,
    faCreativeCommonsSamplingPlus,
    faDatabase,
    faFolder,
    faFileImage,
    faProjectDiagram,
    faUserEdit,
    faCoins,
    faUndo,
    faUserShield,
    faCrown,
    faFilter,
    faHeadset,
    faCogs,
    faGlobe,
    faChartBar,
    faTwitter,
    faTelegram,
    faWhatsapp,
    faHashtag,
    faYoutube,
    faFacebook,
    faWallet,
    faClipboardList,
    faBars,
    faThLarge,
    faCloudArrowUp,
    faFilePdf,
    faProductHunt,
    faPager,
    faHandshake,
    faDolly,
    faUserDoctor,
    faTowerBroadcast,
    faCircleDollarToSlot,
    faRotateLeft,
    faUserTie,
    faShoppingCart,
    faComment,
    faCartShopping,
    faBasketShopping,
    faDiamondTurnRight,
    faCalculator,
    faTruckFast,
    faTruck,
    faDollar,
    faGratipay,
    farFaceGrinStars,
    faFileContract,
    faAddressBook,
    faBullseye,
    faFaceSmile,
    faWpforms,
    faWindowMaximize,
    faBloggerB,
    faMedal,
    faCommentSms,
    farCircleDot,
    faPlay,
})